import { memo } from "react";
import Modal from "react-awesome-modal";

import { URLS } from "global_constants";

import Button from "components/button";
import wizardImg from "assets/graphics/wizard.jpeg";

export default memo(function NoFlowerModal({ visible, onClose }) {
  return (
    <div className="modal">
      <Modal
        width="380"
        effect="fadeInUp"
        visible={visible}
        onClickAway={() => onClose()}
      >
        <div className="p-4 text-center">
          <img alt="Flower" src={wizardImg} className="rounded-2xl m-auto" />
          <div className="px-6 pt-6">
            <p className="font-morh-sb text-2xl mb-1">You shall not pass!</p>
            <p className="text-lg font-morh-m leading-tight">
              Entrance is only granted to Flower Fam NFT or $honeycoin hodlers.
            </p>
          </div>
          <Button
            isPrimary
            onClick={() => window.open(URLS.OPEANSEA, "_blank")}
            classes={["relative", "bottom-[-40px]", "mt-[-20px]"]}
          >
            Buy one on Opensea
          </Button>
        </div>
      </Modal>
    </div>
  );
});
